// The redesigned Risk Setup card look (from the I360A-2067 spike). Applied per
// card via `sx` — deliberately not a page-level wrapper rule.
export const cardSx = {
	p: 3,
	border: 'none',
	borderRadius: '6px',
	background: '#ffffff',
	boxShadow: '0 1px 2px rgba(16,24,40,.05), 0 10px 30px rgba(16,24,40,.06)',
};

// Vertical gap between stacked cards in the left column (spike: 20px).
export const cardGap = 2.5;
